import {useTranslation} from 'react-i18next';

import {Grid, Typography} from '@mui/material';

import {pdfH3} from '../styles';

import {CulturePillarCard} from './CulturePillarCard';
import {
  developmentCommunicationImage,
  handlingEmpathyImage,
  leadershipTeamImage,
  newWorkTrendsImage,
} from '../../../../assets/pdf/culture_pillars';

export const CulturePillarsPageTwo = () => {
  const {t} = useTranslation('pdfDomain');
  const {t: tr} = useTranslation('pdfDomain', {keyPrefix: 'analysisGuide.culturePillars.pageTwo'});

  const culturePillars = [
    {
      image: leadershipTeamImage,
      title: tr('leadershipTeam.title'),
      description: tr('leadershipTeam.description'),
    },
    {
      image: handlingEmpathyImage,
      title: tr('interactionEmpathy.title'),
      description: tr('interactionEmpathy.description'),
    },
    {
      image: newWorkTrendsImage,
      title: tr('newWorkHybridWork.title'),
      description: tr('newWorkHybridWork.description'),
    },
    {
      image: developmentCommunicationImage,
      title: tr('developmentCommunication.title'),
      description: tr('developmentCommunication.description'),
    },
  ];

  return (
    <Grid container p={5}>
      <Typography variant='h3' sx={pdfH3} mr={1} mb={2}>
        {t('analysisGuide.culturePillars.sharedTitle')}
      </Typography>
      <Typography variant='h3' sx={pdfH3}>
        2/2
      </Typography>
      <Grid container item alignItems={'center'}>
        {culturePillars.map((pillar, index) => (
          <CulturePillarCard pillar={pillar} index={index + 4} key={pillar.title} />
        ))}
      </Grid>
    </Grid>
  );
};
